import LegalPage from "../components/LegalPage";

export default function PrivacyPolicyPage() {
  return (
    <LegalPage title="Politique de Confidentialité">
      <p>La présente Politique de Confidentialité décrit comment <strong>Lokaso</strong> (accessible via lokasos.com) collecte, utilise, stocke et protège vos données personnelles. En utilisant notre plateforme, vous acceptez les pratiques décrites dans ce document.</p>

      <h2>1. Responsable du Traitement</h2>
      <p>Lokaso est exploité par son fondateur, Saidou Mamadou Touré, dont le siège est à Conakry, République de Guinée.</p>
      <ul>
        <li>Email : <a href="mailto:admin@lokasos.com">admin@lokasos.com</a></li>
        <li>WhatsApp : <a href="https://wa.me/12402859605">+1 240-285-9605</a></li>
        <li>Site web : <a href="https://lokasos.com">https://lokasos.com</a></li>
      </ul>

      <h2>2. Données Collectées</h2>
      <h3>2.1 Données collectées automatiquement</h3>
      <p>Lorsque vous visitez lokasos.com, nous collectons automatiquement :</p>
      <ul>
        <li>Adresse IP (anonymisée via Google Analytics 4)</li>
        <li>Type de navigateur et système d'exploitation</li>
        <li>Pages visitées et durée des visites</li>
        <li>Termes de recherche utilisés sur la plateforme</li>
        <li>Interactions avec les fiches d'entreprises (clics WhatsApp, appels, partages)</li>
      </ul>
      <h3>2.2 Données fournies volontairement</h3>
      <p>Lorsque vous créez un compte ou réclamez une fiche entreprise :</p>
      <ul>
        <li>Nom et prénom</li><li>Adresse email</li><li>Numéro de téléphone</li>
        <li>Nom et informations de votre entreprise</li><li>Photos et contenus uploadés</li>
      </ul>
      <h3>2.3 Données des entreprises listées</h3>
      <p>Lokaso a importé des informations d'entreprises depuis des sources publiques disponibles en Guinée. Ces données incluent : nom de l'entreprise, adresse, numéro de téléphone, catégorie d'activité. Aucune donnée financière ou personnelle sensible n'a été importée.</p>

      <h2>3. Utilisation des Données</h2>
      <p>Vos données sont utilisées pour :</p>
      <ul>
        <li>Fournir et améliorer les services de l'annuaire Lokaso</li>
        <li>Permettre la gestion de votre fiche entreprise</li>
        <li>Vous envoyer des communications relatives à votre compte (via Resend)</li>
        <li>Analyser l'utilisation de la plateforme via Google Analytics 4</li>
        <li>Prévenir les fraudes et assurer la sécurité de la plateforme</li>
        <li>Répondre à vos demandes de support</li>
      </ul>

      <h2>4. Base Légale du Traitement</h2>
      <ul>
        <li><strong>Exécution d'un contrat</strong> : pour la gestion de votre compte et fiche entreprise</li>
        <li><strong>Intérêt légitime</strong> : pour l'amélioration de nos services et la sécurité de la plateforme</li>
        <li><strong>Consentement</strong> : pour l'envoi d'emails marketing (vous pouvez vous désinscrire à tout moment)</li>
        <li><strong>Obligation légale</strong> : lorsque la loi guinéenne ou applicable l'exige</li>
      </ul>

      <h2>5. Partage des Données</h2>
      <p>Lokaso <strong>ne vend jamais</strong> vos données personnelles. Nous partageons vos données uniquement avec :</p>
      <ul>
        <li>Google Analytics (analyse d'audience — IP anonymisées)</li>
        <li>Resend (envoi d'emails transactionnels)</li>
        <li>MongoDB Atlas (hébergement sécurisé de la base de données)</li>
        <li>Emergent / hébergeur de l'application (infrastructure technique)</li>
      </ul>
      <p>Ces prestataires sont contractuellement tenus de protéger vos données et de ne pas les utiliser à d'autres fins.</p>

      <h2>6. Conservation des Données</h2>
      <ul>
        <li>Données de compte : conservées tant que votre compte est actif + 3 ans après fermeture</li>
        <li>Données de navigation (GA4) : 14 mois (paramètre GA4 par défaut)</li>
        <li>Emails envoyés : logs conservés 12 mois dans Resend</li>
        <li>Fiches entreprises non réclamées : conservées indéfiniment (données publiques)</li>
      </ul>

      <h2>7. Vos Droits</h2>
      <p>Conformément au RGPD (pour les utilisateurs européens) et aux principes de protection des données applicables :</p>
      <ul>
        <li><strong>Droit d'accès</strong> : obtenir une copie de vos données</li>
        <li><strong>Droit de rectification</strong> : corriger des données inexactes</li>
        <li><strong>Droit à l'effacement</strong> : demander la suppression de vos données</li>
        <li><strong>Droit à la portabilité</strong> : recevoir vos données dans un format structuré</li>
        <li><strong>Droit d'opposition</strong> : vous opposer au traitement de vos données</li>
        <li><strong>Droit de retrait du consentement</strong> : à tout moment pour les communications marketing</li>
      </ul>
      <p>Pour exercer ces droits, contactez-nous à <a href="mailto:admin@lokasos.com">admin@lokasos.com</a>. Nous répondons sous 30 jours.</p>

      <h2>8. Cookies</h2>
      <p>Lokaso utilise les technologies suivantes :</p>
      <ul>
        <li>Cookies Google Analytics (_ga, _gid) : analyse d'audience, durée 2 ans</li>
        <li>Cookies de session : maintien de votre connexion, durée de la session</li>
        <li>LocalStorage : préférences utilisateur</li>
      </ul>
      <p>Vous pouvez gérer vos préférences cookies via votre navigateur. Voir aussi notre <a href="/politique-cookies">Politique de Cookies</a>.</p>

      <h2>9. Sécurité</h2>
      <ul>
        <li>Connexions chiffrées HTTPS/TLS sur toutes les pages</li>
        <li>Mots de passe hashés (bcrypt)</li>
        <li>Authentification JWT pour les accès administrateurs</li>
        <li>Base de données MongoDB Atlas avec accès restreint</li>
        <li>Pas de stockage de données de paiement sur nos serveurs</li>
      </ul>

      <h2>10. Transferts Internationaux</h2>
      <p>Vos données peuvent être traitées dans des pays en dehors de la Guinée, notamment aux États-Unis (Google Analytics, MongoDB Atlas). Ces transferts sont encadrés par des clauses contractuelles types conformes aux standards internationaux de protection des données.</p>

      <h2>11. Enfants</h2>
      <p>Lokaso n'est pas destiné aux personnes de moins de 16 ans. Nous ne collectons pas sciemment de données personnelles concernant des mineurs. Si vous pensez qu'un mineur nous a fourni des données, contactez-nous immédiatement à <a href="mailto:admin@lokasos.com">admin@lokasos.com</a>.</p>

      <h2>12. Modifications</h2>
      <p>Nous pouvons modifier cette politique à tout moment. La date de « Dernière mise à jour » en haut sera actualisée. Pour les modifications substantielles, nous vous informerons par email si vous avez un compte Lokaso.</p>

      <h2>13. Contact</h2>
      <ul>
        <li>Email : <a href="mailto:admin@lokasos.com">admin@lokasos.com</a></li>
        <li>WhatsApp : <a href="https://wa.me/12402859605">+1 240-285-9605</a></li>
        <li>Adresse : Conakry, République de Guinée</li>
      </ul>
    </LegalPage>
  );
}
